import { Component, OnInit, ViewChild } from '@angular/core';
import { getStyle, hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities';
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips';
import { ConstantService } from '../../../services/constant.service';
import * as moment from 'moment';
import * as _ from 'lodash';
import { ApiService } from '../../../services/api.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Module, AllCommunityModules, RowNode } from '@ag-grid-community/all-modules';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ImageRendererComponent } from '../../../renderer/image-renderer.component';

@Component({
  templateUrl: 'dashboard.component.html'
})
export class PersonalDashboardComponent implements OnInit {
  @ViewChild('attachmentModal') public attachmentModal: ModalDirective;

  public gridApi;
  public gridColumnApi;
  public gridOptions;
  public modules: Module[] = AllCommunityModules;
  public context;
  public frameworkComponents;
  public defaultColDef;
  public columnDefs;
  public attendanceColDef;
  public expenseColDef;
  public permission;
  public rowClassRules;
  public rowSelection;
  public currentTime = moment().format('YYYY-MM-DD HH:mm:ss');

  dt1: '';

  userAccess = {
    type: '',
  };
  fullAccess = ['admin', 'operator'];
  
  bgColor: string[] = ['bg-success', 'bg-info', 'bg-warning', 'bg-danger', 'bg-success', 'bg-primary'];
  totalEmployee : any = '';
  username : string = '';



  constructor(private constantService: ConstantService, private apiService: ApiService) {
    this.userAccess = {
      type: this.constantService.getCookies().TYPE
    }
    this.username = this.constantService.getCookies().USERNAME;
    this.frameworkComponents = {
      imageButtonRenderer : ImageRendererComponent,
    };

    this.context = { componentParent: this };
    this.defaultColDef = {
      sortable: true,
      filter: true,
      resizable: true,
      flex: 1,
      floatingFilter: false,
      filterParams: { buttons: ['clear'] }
    };
    this.attendanceColDef = [
      { headerName: 'Date', field: 'date' },
      { headerName: 'User name', field: 'username' },
      { headerName: 'Full Name', field: 'fullName' },
      { headerName: 'Address', field: 'address' },
    ]
    this.attendanceColDef.push(
      { headerName: 'Attachment', field: 'value', cellRenderer: 'imageButtonRenderer', colId: 'paramsImg',  width: 100, filter: false, resizable: true, sortable: false,cellClass: ['text-center'],  },
      );
      
    this.expenseColDef = [
      { headerName: 'Date', field: 'exp_date' },
      { headerName: 'User name', field: 'username' },
      { headerName: 'Full Name', field: 'full_name' },
      { headerName: 'Expense Head', field: 'head' },
      { headerName: 'Amount', field: 'amount' },
      { headerName: 'Narration', field: 'narration' },
      { headerName: 'Approved', field: 'approved' },
    ]
    this.expenseColDef.push(
      { headerName: 'Attachment', field: 'value', cellRenderer: 'imageButtonRenderer', colId: 'paramsImg',  width: 100, filter: false, resizable: true, sortable: false,cellClass: ['text-center'],  },
      );
  }

  

  ngOnInit(): void {
    this.fetchTodayAttendance();
    this.getCountBySectorAndDept();
    
    this.fetchEmployee();
    this.getExpenseAmount();
  }
  todayEnd = moment().endOf("day").format("YYYY-MM-DD HH:mm:ss");
  todayStart = moment().startOf("day").format("YYYY-MM-DD HH:mm:ss");


  
  todaysAttendace: any = [];
  todaysExpesne: any = [];
  
  fetchTodayAttendance() {
    let queryString = "* from attendance WHERE `date` BETWEEN '"+this.todayStart+"' AND '"+this.todayEnd+"' AND username LIKE '" + this.username + "'"; 
    console.log(queryString);
    this.apiService.getCustomData(btoa(queryString)).subscribe((resp: any) => {
      this.todaysAttendace = resp;
      console.log(this.todaysAttendace)
    })
  }
  employeesObj: any = {};
  fetchEmployee(){
    let queryString = " full_name, phone_no from employees"; 
    console.log(queryString);
    this.apiService.getCustomData(btoa(queryString)).subscribe((resp: any) => {
      this.totalEmployee = resp.length;
      _.each(resp, (data: any) => {
        this.employeesObj[data.phone_no] = data.full_name;
      })
      this.fetchTodayExpense();
    })
  }
  fetchTodayExpense() {
    let queryString = "* from expense WHERE DATE(exp_date) = CURDATE() AND username LIKE '" + this.username + "'"; 
    console.log(queryString);
    this.apiService.getCustomData(btoa(queryString)).subscribe((resp: any) => {
      this.todaysExpesne = resp;
      _.each(resp, (data: any) => {
        data['full_name'] = this.employeesObj[data.username] ? this.employeesObj[data.username].fullName : '';
      })
      console.log(this.todaysExpesne)
    })
  }
  onGridReady(params) {
    
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }
  dashboardData: any = [];
  getCountBySectorAndDept() {
    this.dashboardData = [];
    let queryString = "COUNT( CASE WHEN DATE(date) = CURDATE()  AND `punch_slot` = '09:00-10:00' THEN 1 END ) AS firstSlot,"+
    " COUNT( CASE WHEN DATE(date) = CURDATE()  AND `punch_slot` = '12:00-13:00' THEN 1 END ) AS secondSlot, "+
    " COUNT( CASE WHEN DATE(date) = CURDATE()  AND `punch_slot` = '14:00-15:00' THEN 1 END ) AS thirdSlot,"+
    " COUNT( CASE WHEN DATE(date) = CURDATE()  AND `punch_slot` = '17:00-18:00' THEN 1 END ) AS fourthSlot"+
    " FROM attendance WHERE username LIKE '" + this.username + "'";
    
    
    console.log(queryString);
    this.apiService.getCustomData(btoa(queryString)).subscribe((resp: any) => {
      let data = resp[0];
      let keys = Object.keys(data);
      console.log(data);
      console.log(keys);
      let count = 0;
      _.each(keys, (key) => {
        if (count > 3) {
          count = 0;
        } else {
          count++;
        }
        if(key === 'firstSlot') {this.dashboardData.push({id: 1, category: 'overall', label: '09:00-10:00', count: data[key], bg: this.bgColor[count]})}
        if(key === 'secondSlot') {this.dashboardData.push({id: 2, category: 'overall', label: '12:00-13:00', count: data[key], bg: this.bgColor[count]})}
        if(key === 'thirdSlot') {this.dashboardData.push({id: 3, category: 'overall', label: '14:00-15:00', count: data[key], bg: this.bgColor[count]})}
        if(key === 'fourthSlot') {this.dashboardData.push({id: 4, category: 'overall', label: '17:00-18:00', count: data[key], bg: this.bgColor[count]})}
        
      })

      this.dashboardData = _.sortBy(this.dashboardData, 'id')
    });
  
  }
  
  expenseData: any = [];
  getExpenseAmount() {
    this.expenseData = [];
    let queryString = "SUM( CASE WHEN DATE(exp_date) = CURDATE()  AND `approved` = 'Yes' THEN amount END ) AS approved,"+
    " SUM( CASE WHEN DATE(exp_date) = CURDATE()  AND `approved` = 'No' THEN amount END ) AS notApproved, "+
    " SUM( CASE WHEN DATE(exp_date) = CURDATE() THEN amount END ) AS total"+
    " FROM expense WHERE username LIKE '" + this.username + "'";
    
    
    console.log(queryString);
    this.apiService.getCustomData(btoa(queryString)).subscribe((resp: any) => {
      let data = resp[0];
      let keys = Object.keys(data);
      console.log(data);
      console.log(keys);
      let count = 0;
      _.each(keys, (key) => {
        if (count > 3) {
          count = 0;
        } else {
          count++;
        }
        if(key === 'approved') {this.expenseData.push({id: 2, category: 'exp', label: 'Approved', count: data[key], bg: this.bgColor[count]})}
        if(key === 'notApproved') {this.expenseData.push({id: 3, category: 'exp', label: 'Not Approved', count: data[key], bg: this.bgColor[count]})}
        if(key === 'total') {this.expenseData.push({id: 1, category: 'exp', label: 'Total', count: data[key], bg: this.bgColor[count]})}
        
      })

      this.expenseData = _.sortBy(this.expenseData, 'id')
    });
  
  }

  selectedData: any = {};
  methodFromParent(userData) {
    this.selectedData = userData;
    console.log(this.selectedData, userData.action);
    if(userData.action === 'image') {
      this.attachmentModal.show();
    }
    
    
  }

}
